import { IAnonymousStudentService } from '@studyportals/anonymous-student-interfaces';
import { StudentField, IStudent } from '@studyportals/studentdomain';
import globals from '../utils/globals';

export class StudentClient {
	private client: IAnonymousStudentService;

	constructor() {
		this.client = globals.anonymousStudent;
	}

	public async getData(fields: StudentField[]): Promise<IStudent | null> {
		try {
			return await this.client.getStudentData(fields);
		} catch {
			return null;
		}
	}

	public async getCompleteness(fields: StudentField[]): Promise<number> {
		try {
			return await this.client.getStudentDataCompleteness(fields);
		} catch {
			return 0;
		}
	}
}
